/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Switcher_LabelInputs */

const en_map_switcher_label = /** @type {(inputs: Map_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map`)
};

const fr_map_switcher_label = /** @type {(inputs: Map_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte`)
};

const ms_sg2_map_switcher_label = /** @type {(inputs: Map_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta`)
};

/**
* | output |
* | --- |
* | "Map" |
*
* @param {Map_Switcher_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_switcher_label = /** @type {((inputs?: Map_Switcher_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Switcher_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_switcher_label(inputs)
	if (locale === "fr") return fr_map_switcher_label(inputs)
	return ms_sg2_map_switcher_label(inputs)
});